import React from 'react';

import { section } from './settings.js';

import './Filters.css';

const filterHeadings = {
  Group: 'Group Name',
  Type: 'Flyer Type',
};

export default class Filters extends React.Component {
  _toggleFilter = (group, value) => {
    return () => {
      const numSelectedInGroup = Object.keys(this.props.filters[group])
        .reduce((accumulator, nextValue) => {
          return accumulator + (this.props.filters[group][nextValue].selected ? 1 : 0)
        }, 0)
      const isDeselecting = this.props.filters[group][value.name].selected
      if (isDeselecting && numSelectedInGroup === 1) {
        return
      }
      this.props.toggleFilter(group, value)
    }
  }

  render() {
    const total = this.props.groups.Type.top.map(t => t.count).reduce((a, v) => a + v, 0);
    const groups = Object.keys(this.props.filters).map(g => {
      const selected = (g === this.props.group) ? 'selected' : '';
      const toggles = this.props.groups[g].top.map(v => {
        const className = v.name.length > 30 ? 'filterGroup large' : 'filterGroup';
        return (
          <div
            key={v.name}
            className={className}
            onClick={this._toggleFilter(g, v)}>
            <div
              className='groupCount compactFont'
              style={{ color: section(v.name).color }}
            >
              {v.count}
            </div>
            <div className='groupName'>
              {v.name.replace(/\//g, ' / ')}
            </div>
            <div className='checkcover' />
            <label className='checkbox'>
              <input
                type='checkbox'
                checked={v.selected}
                readOnly={true}
              />
              <span className='checkmark'></span>
            </label>
          </div>
        )
      });
      return (
        <div key={g}>
          <div
            className={`filterHeading ${selected}`}
            onClick={() => this.props.swapGroup(g)}
          >
            {filterHeadings[g]}
          </div>
          {toggles}
        </div>
      )
    });
    return (
      <div className='filters'>
        {groups}
        <div className='filterTotal filterGroup'>
          <div
            className='groupCount compactFont'
            style={{ color: 'white' }}
          >
            {total}
          </div>
          <div className='groupName'>USA TOTAL</div>
        </div>
      </div>
    )
  }
}
